import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path } from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Table from '../../сomponents/Table';
import ConfirmAction from '../../common/ConfirmAction';
import { changeModalState } from '../../actions/modal';
import { deleteObject } from '../../actions/objectToDelete';
import { getList, removeProjectById } from '../../api/projects';
import Preloader from '../../common/Preloader';
import './style.css';
import hasAccess from "../../helpers/permissionChecker";

export class Customers extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.handlerDelete = this.handlerDelete.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.handlerOrder = this.handlerOrder.bind(this);
    this.handlerTask = this.handlerTask.bind(this);
    this.addCustomer = this.addCustomer.bind(this);
    this.getCustomers = this.getCustomers.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);

    this.state = {
      items: Array.from([]),
      container: false,
      search: '',
      itemsPerPage: 10,
      currentPage: 0,
    };

    this.columns = [
      'name',
      'created',
    ];

    this.columnNames = [
      'Name',
      'Date Created',
    ];
  }

  addCustomer() {
    this.props.moveToAdd();
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    });
  }

  componentWillMount() {
    this.props.loadList();
  }

  handlerDelete(id) {
    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: removeProjectById,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'removeProjectById',
    });
  }

  handlerEdit(id) {
    this.props.moveToEdit(id);
  }

  handlerOrder() {
    this.props.moveToOrder();
  }

  handlerTask(id) {
    this.props.moveToTask(id);
  }

  getCustomers() {
    let userLevel = path(['users', 'userProfile', 'user_level'], this.props);
    let projectsList = path(['projects', 'list'], this.props);
    let itemActions = {};

    if (!projectsList) {
      return null;
    }

    itemActions = {
      tasks: {
        handler: this.handlerTask,
        permission: { 'permAreaKey': 'workOrder', 'permTypeKey': 'view' },
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-table icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'tasks',
      },
      edit: {
        handler: this.handlerEdit,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
        permission: { 'permAreaKey': 'customer', 'permTypeKey': 'edit' },
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'edit',
      },
      delete: {
        handler: this.handlerDelete,
        authorColumnName: 'user_id',
        permission: { 'permAreaKey': 'customer', 'permTypeKey': 'delete' },
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'delete',
      }
    };

    if (!projectsList || projectsList.length === 0) {
      projectsList = [];
    }

    return (
      <Table
        items={projectsList}
        columns={this.columns}
        columnNames={this.columnNames}
        itemsPerPage={this.state.itemsPerPage}
        search={this.state.search}
        currentPage={this.state.currentPage}
        onChangeCurrentPage={this.onChangeCurrentPage}
        actions={itemActions}
        onSearch={this.onSearch}
        onChangeItemsPerPage={this.onChangeItemsPerPage}
      />
    );
  }

  render() {
    const customers = this.getCustomers();
    let preloader = null;

    if (customers === null) {
      preloader = (
        <Preloader
          show={true}
          type={'circle'}
        />
      );
    }

    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { icon: 'account_circle', name: 'Customers' },
        ]}/>
        <div className="card rounded">
          <div className="card-header rounded-top">
            Customers
          </div>
          <div className="card-block">
            {hasAccess({ 'permAreaKey': 'customer', 'permTypeKey': 'create' }) &&
            <div className="clearfix mb-3">
              <button className="btn btn-rounded btn-icon ui-btn pull-right" onClick={this.addCustomer}>
                <i className="material-icons">add_circle_outline</i>
                <span className="color-default">Add</span>
              </button>
            </div>
            }
            {preloader}
            {customers}
            <ConfirmAction id={'removeProjectById'}/>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {

    loadList: () => {
      getList()(dispatch)
    },
    moveToTask: (id) => {
      dispatch(push('/pages/project-task/' + id));
    },
    moveToOrder: () => {
      dispatch(push('/pages/work-order'));
    },
    moveToEdit: (id) => {
      dispatch(push('/pages/edit-customer/' + id));
    },
    moveToDelete: () => {
      dispatch(push('/pages/job-cards-delete'));
    },
    moveToAdd: () => {
      dispatch(push('/pages/customer'));
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Customers);



// WEBPACK FOOTER //
// ./src/containers/Customers/index.js